const sidepanel = {
	overlayVariants: {
		closed: {
			opacity: 0,
			transition: { delay: 0.5 },
		},
		opened: {
			opacity: 0.5,
		},
	},
	opacityVariants: {
		closed: {
			opacity: 0,
		},
		open: {
			opacity: 1,
			transition: { delay: 0.5 },
		},
	},
};

const cards = {
	opacityVariants: {
		initial: {
			opacity: 0,
		},
		animate: {
			opacity: 1,
		},
	},
};

const Animation = {
	sidepanel,
	cards,
};

export default Animation;
